module.exports = __webpack_public_path__ + "static/img/pybk_effect_bg.4a6a46a.png";